import { PipeTransform, Pipe } from "@angular/core";
@Pipe({
    name:'StringToDateDay'
})

export class StringToDateDay implements PipeTransform {
    //constructor (){}
    transform (value:any){
      if (value) {
        var dateFormat = require('dateformat');
        var date = new Date(Number(value));
        return (dateFormat(date, "dd/mm/yyyy").toString());
      }
    }
}
